import * as React from "react";
import { Seo } from "../components/seo";
import Layout from "../components/layout";
import { Link } from "gatsby";

const IndexPage = () => {
  return (
    <Layout currentPath="/">
      <div className="flex flex-col w-full items-center justify-center">

        <section className="bg-gray-900">
          <div className="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 grid lg:grid-cols-2 gap-8 lg:gap-16">
            <div className="flex flex-col justify-center">
              <h1 className="mb-4 text-4xl font-extrabold tracking-tight leading-none text-white md:text-5xl lg:text-6xl">
                Share the Gospel in less than three minutes
              </h1>
              <p className="mb-8 text-lg font-normal text-gray-400 lg:text-xl">
                The Two Circles is a simple presentation of the gospel that
                explains what Jesus did for us on the cross and brings a person to the point of
                making a Salvation decision.
              </p>
              <div className="flex flex-col space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4">
                <Link
                  to="/presentation"
                  className="inline-flex justify-center items-center py-3 px-5 text-base font-medium text-center text-white rounded-lg bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-900"
                >
                  Share now
                  <svg
                    className="w-3.5 h-3.5 ml-2"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 10"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M1 5h12m0 0L9 1m4 4L9 9"
                    />
                  </svg>
                </Link>
                <Link
                  to="/about"
                  className="inline-flex justify-center items-center py-3 px-5 text-base font-medium text-center rounded-lg border focus:ring-4 text-white border-gray-700 hover:bg-gray-700 focus:ring-gray-800"
                >
                  Learn more
                </Link>
              </div>
            </div>
            <div>
              <iframe
                className="mx-auto w-full lg:max-w-xl h-64 rounded-lg sm:h-96 shadow-xl"
                src="https://www.youtube.com/embed/VZaTlQ-RaFM?si=L2w6nWd9_gbQ9w3B"
                title="The Two Circles"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </section>

        {/* <div className="flex m-8 w-full h-[500px] justify-center items-center">
          <iframe
            className="w-[80%] h-full"
            src="https://www.youtube.com/embed/VZaTlQ-RaFM?si=L2w6nWd9_gbQ9w3B"
            title="The Two Circles"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </div> */}
      </div>
    </Layout>
  );
};

export default IndexPage;

export const Head = () => <Seo />;
